'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DummyComponent = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

exports.DefaultErrorComponent = DefaultErrorComponent;
exports.DefaultLoadingComponent = DefaultLoadingComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var DummyComponent = exports.DummyComponent = function (_React$Component) {
  (0, _inherits3.default)(DummyComponent, _React$Component);

  function DummyComponent() {
    (0, _classCallCheck3.default)(this, DummyComponent);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(DummyComponent).apply(this, arguments));
  }

  (0, _createClass3.default)(DummyComponent, [{
    key: 'render',
    value: function render() {
      return null;
    }
  }]);
  return DummyComponent;
}(_react2.default.Component);

function DefaultErrorComponent(_ref) {
  var error = _ref.error;
  return _react2.default.createElement('pre', {
    style: {
      color: 'red'
    }
  }, error.message, ' ', _react2.default.createElement('br', null), error.stack);
}

function DefaultLoadingComponent() {
  return _react2.default.createElement('p', null, 'Loading...');
}